import { Dropdown } from 'react-bootstrap';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import moment from 'moment';
import Tippy from '@tippyjs/react';
import { setNotificationAsRead } from '../../actions/notification';

const NotificationList = () => {
  const { requestNotification, count } = useSelector(
    (state) => state.notificationReducer
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const redirectUrl = (urlParam) => {
    if (urlParam === '/timeoff/requests') {
      history.push(urlParam);
    } else if (location.pathname !== `/projects/${urlParam}/task-board`) {
      history.push(`/projects/${urlParam}/task-board`);
      history.go(0);
    }
  };

  return (
    <Dropdown className="btn text-white font-size-lg p-0">
      <Link
        to="#"
        onClick={() => {
          if (requestNotification.length > 0) {
            dispatch(
              setNotificationAsRead(
                requestNotification.map((item) =>
                  item.message ? item._id : ''
                )
              )
            );
          }
        }}
      >
        <Dropdown.Toggle className="dropdown-ellipses dropdown-toggle">
          {count > 0 && (
            <span className="notification-icon-badge">{count}</span>
          )}
          <Tippy content="Notifications" theme="light">
            <i className="mdi mdi-bell-outline text-white icon-20px" />
          </Tippy>
        </Dropdown.Toggle>
      </Link>
      {requestNotification && requestNotification.length > 0 ? (
        <Dropdown.Menu
          align="left"
          style={{ maxHeight: '300px', minWidth: '320px', overflowY: 'auto' }}
        >
          {requestNotification.map((item) => (
            <Dropdown.Item
              key={item._id}
              as={Link}
              to="#"
              style={{ whiteSpace: 'normal' }}
              onClick={() => {
                if (item.category === 'task_due') {
                  redirectUrl(item.projectId);
                } else if (item.category === 'time_off_request') {
                  redirectUrl('/timeoff/requests');
                }
              }}
            >
              {item.message}
              {item.category === 'daily_limit' && item.limit ? (
                <p className="mb-0">{`Threshold Limit : ${item.limit} hours`}</p>
              ) : (
                ''
              )}
              {item.category === 'task_due' ? (
                ''
              ) : (
                <p className="mb-1" style={{ fontSize: '13px' }}>
                  {moment(item.createdDate).format('MMM D YYYY, h:mm a')}
                </p>
              )}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      ) : (
        ''
      )}
    </Dropdown>
  );
};

export default NotificationList;
